<template>
  <div class="body rtls auth-shell">
    <div class="auth-brand">
      <div class="brand-glow brand-glow-1"></div>
      <div class="brand-glow brand-glow-2"></div>
      <div class="brand-grid"></div>
      <div class="auth-brand-content">
        <div class="brand-mark-lg">{{ ($appName || "پ").charAt(0) }}</div>
        <h1 class="brand-title">{{ $appName }}</h1>
        <p class="brand-tagline" v-if="$appDescription">{{ $appDescription }}</p>
      </div>
    </div>
    <div class="auth-form-panel">
      <div class="middle-box loginscreen animated fadeInDown">
        <div class="content-centered">
          <div class="auth-form-header">
            <h2 class="auth-form-title">ورود به پنل مدیریت</h2>
            <p class="auth-form-subtitle">اطلاعات کاربری خود را وارد کنید</p>
          </div>
          <div class="adittional">
            <form class="m-t" role="form">
              <div :class="`form-group ${hasError ? 'has-error' : ''}`">
                <label class="auth-label">شماره‌موبایل یا نام‌کاربری</label>
                <input
                  type="email"
                  class="form-control"
                  placeholder="شماره‌موبایل یا نام‌کاربری"
                  required="true"
                  v-model="login.login"
                />
              </div>
              <div :class="`form-group ${hasError ? 'has-error' : ''}`">
                <label class="auth-label">کلمه‌عبور</label>
                <input
                  type="password"
                  class="form-control"
                  placeholder="کلمه‌عبور"
                  required="true"
                  v-model="login.password"
                />
              </div>
              <h3 v-if="hasError" class="text-danger">
                {{ errorMessage }}
              </h3>
              <button
                @click.prevent="logUserIn"
                type="submit"
                class="btn btn-primary block full-width m-b"
              >
                ورود
              </button>
            </form>

            <p class="m-t auth-footer">
              <small
                >تمام حقوق و امتیاز سایت متعلق به شرکت بیتا ایده می باشد .</small
              >
              {{ $appVersion }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/auth";
export default {
  data() {
    return {
      login: {
        login: "",
        password: "",
      },
      hasError: false,
      errorMessage: "",
    };
  },
  mounted() {
    this.$setLayout("simple-layout");
  },
  methods: {
    logUserIn() {
      if (!this.login.login || !this.login.password) {
        this.hasError = true;
        this.errorMessage = "اطلاعات کامل وارد نشده است";
        return;
      }
      this.$setIsLoading(true);
      api.getCsrf().then(() => {
        api
          .login(this.login)
          .then((res) => {
            this.$store.dispatch("login", res.data);
            this.$router.push("/");
          })
          .catch((error) => {
            this.hasError = true;
            this.errorMessage = error.response?.data?.message;
          })
          .finally(() => {
            setTimeout(() => {
              this.$setIsLoading(false);
            }, 500);
          });
      });
    },
  },
};
</script>
<style scoped>
.body.rtls.auth-shell {
  min-height: 100vh;
  display: flex;
  background: #f8fafc !important;
  padding: 0;
}

/* ---------- brand panel (right side, matching the sidebar's dark surface) ---------- */

.auth-brand {
  position: relative;
  flex: 0 0 44%;
  max-width: 560px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #0c0e16 0%, #14161f 60%, #1a1d2b 100%);
  overflow: hidden;
}

.brand-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(60px);
  pointer-events: none;
}

.brand-glow-1 {
  width: 320px;
  height: 320px;
  top: -80px;
  right: -80px;
  background: radial-gradient(circle, rgba(129, 140, 248, 0.35) 0%, transparent 70%);
}

.brand-glow-2 {
  width: 380px;
  height: 380px;
  bottom: -120px;
  left: -100px;
  background: radial-gradient(circle, rgba(79, 70, 229, 0.28) 0%, transparent 70%);
}

.brand-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: radial-gradient(circle at center, black 0%, transparent 75%);
}

.auth-brand-content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding: 40px;
}

.brand-mark-lg {
  width: 64px;
  height: 64px;
  margin: 0 auto 24px;
  border-radius: 18px;
  background: linear-gradient(135deg, #818cf8 0%, #4f46e5 100%);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.6rem;
  box-shadow: 0 12px 24px -6px rgba(79, 70, 229, 0.45);
}

.brand-title {
  color: #f8fafc;
  font-size: 1.9rem !important;
  font-weight: 800 !important;
  margin: 0 0 10px !important;
}

.brand-tagline {
  color: #9aa1b5;
  font-size: 0.9rem;
  max-width: 320px;
  margin: 0 auto;
  line-height: 1.9;
}

/* ---------- form panel (left side) ---------- */

.auth-form-panel {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.btn {
  background-color: #4f46e5 !important;
  border: 1px solid #4f46e5 !important;
  border-radius: 10px !important;
  transition: background-color 150ms ease;
}
.btn:hover {
  background-color: #4338ca !important;
  border-color: #4338ca !important;
}

.middle-box {
  max-width: 380px;
  width: 100%;
  z-index: 100;
  position: relative;
  margin: 0 auto;
}
.content-centered {
  position: relative;
  top: auto;
  right: auto;
  transform: none;
}
.loginscreen.middle-box {
  width: 100%;
  background: transparent;
  padding: 0;
  box-shadow: none;
}

.auth-form-header {
  text-align: center;
  margin-bottom: 28px;
}

.auth-form-title {
  color: #1e293b;
  font-size: 1.4rem !important;
  font-weight: 800 !important;
  margin-bottom: 6px !important;
}

.auth-form-subtitle {
  color: #64748b;
  font-size: 0.85rem;
  margin: 0;
}

.auth-label {
  display: block;
  text-align: right;
  font-size: 0.78rem;
  font-weight: 600;
  color: #475569;
  margin-bottom: 6px;
}

input {
  text-align: right;
  height: 44px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  box-shadow: none;
  padding: 0 14px !important;
}
input:focus {
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}

.auth-footer {
  text-align: center;
  color: #94a3b8;
  font-size: 0.72rem;
  margin-top: 20px;
}

a.btn.btn-primary.block.full-width.m-b {
  height: 44px;
  line-height: 30px;
  color: #fff;
  font-weight: 600;
}

@media (max-width: 860px) {
  .auth-brand {
    display: none;
  }
  .auth-form-panel {
    flex: 1 1 100%;
  }
}
</style>
